export default __webpack_public_path__ + "assets/arrow-drop-down.91ab890c.svg";